import { makeStyles, Theme } from '@material-ui/core';
import { FC } from 'react';
import { OverlayView } from 'react-google-maps';
import clsx from 'clsx';

interface ICustomInfoWindowProps {
  lat: number;
  lng: number;
  onClick: any;
  title: string;
  address: string;
  isShown: boolean;
}
const getPixelPositionOffset = (width: number, height: number) => ({
  x: width / (width / 2),
  y: -height - 50,
});

export const CustomInfoWindow: FC<ICustomInfoWindowProps> = ({
  isShown,
  lat,
  lng,
  title,
  address,
}) => {
  const classes = useStyles({ isShown });
  return (
    <div>
      <OverlayView
        key={`${lat}${lng}`}
        position={{ lat, lng }}
        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
        getPixelPositionOffset={getPixelPositionOffset}
      >
        <>
          <div className={clsx(classes.overlay, classes.shown)}>
            <h3 className={classes.title}>{title}</h3>
            <p className={classes.address}>{address}</p>
          </div>
          <div className={clsx(classes.triangle, classes.shown)}></div>
        </>
      </OverlayView>
    </div>
  );
};
const useStyles = makeStyles((theme: Theme) => ({
  shown: ({ isShown }: { isShown: boolean }) => {
    return isShown ? { display: 'block' } : { display: 'none' };
  },
  title: {
    color: theme.palette.secondary.main,
    fontSize: '21px',
    margin: '1.5rem 0 .75rem 0',
  },
  address: {
    color: '#848e9f',
    fontSize: '17.5px',
    margin: '.75rem 0 1.25rem 0',
  },
  overlay: {
    position: 'relative',
    borderRadius: '1rem 1rem 1rem 0',
    padding: '.5rem 1rem',
    backgroundColor: '#fff',
    maxWidth: 225,
    boxShadow: '0px 3px 15px rgba(0,0,0,0.2)',
    zIndex: -1,
  },
  triangle: {
    width: 0,
    borderTop: '20px solid #fff',
    borderRight: '20px solid transparent',
    cursor: 'pointer',
  },
}));
